// ============================================================================
// FNE-BRIDGE - Store Tableau de Bord (Zustand)
// ============================================================================

import { create } from 'zustand';
import type {
  DashboardSummary,
  StickerDailySummary,
  RecentInvoice,
} from '../types/models';
import type { DashboardFilters } from '../types/api';

// ============================================================================
// Types du state
// ============================================================================

export interface SalesEvolution {
  jour: string;
  total_ht: number;
  total_ttc: number;
  count: number;
}

interface DashboardState {
  // Données
  summary: DashboardSummary | null;
  stickers7j: StickerDailySummary[];
  dernieresFactures: RecentInvoice[];
  evolutionVentes: SalesEvolution[];

  // Filtres
  filters: DashboardFilters;

  // Chargement
  isLoading: boolean;
  error: string | null;

  // Actions
  setSummary: (summary: DashboardSummary) => void;
  setStickers7j: (stickers7j: StickerDailySummary[]) => void;
  setDernieresFactures: (factures: RecentInvoice[]) => void;
  setEvolutionVentes: (evolution: SalesEvolution[]) => void;
  setDashboardData: (
    summary: DashboardSummary,
    stickers7j: StickerDailySummary[],
    dernieresFactures: RecentInvoice[],
    evolutionVentes: SalesEvolution[]
  ) => void;
  setFilters: (filters: Partial<DashboardFilters>) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  reset: () => void;
}

// ============================================================================
// Store
// ============================================================================

export const useDashboardStore = create<DashboardState>()((set) => ({
  summary: null,
  stickers7j: [],
  dernieresFactures: [],
  evolutionVentes: [],
  filters: { periode_jours: 14 },
  isLoading: false,
  error: null,

  setSummary: (summary) => set({ summary }),
  setStickers7j: (stickers7j) => set({ stickers7j }),
  setDernieresFactures: (dernieresFactures) => set({ dernieresFactures }),
  setEvolutionVentes: (evolutionVentes) => set({ evolutionVentes }),

  setDashboardData: (summary, stickers7j, dernieresFactures, evolutionVentes) =>
    set({ summary, stickers7j, dernieresFactures, evolutionVentes, isLoading: false, error: null }),

  setFilters: (filters) =>
    set((state) => ({ filters: { ...state.filters, ...filters } })),

  setLoading: (isLoading) => set({ isLoading, error: null }),
  setError: (error) => set({ error, isLoading: false }),

  reset: () =>
    set({
      summary: null,
      stickers7j: [],
      dernieresFactures: [],
      evolutionVentes: [],
      filters: { periode_jours: 14 },
      isLoading: false,
      error: null,
    }),
}));
